export default __webpack_public_path__ + "static/media/boiled_egg.3a03de8a.png";